/**
 * Tipos de estado de cuenta del cliente para la validación
 */
export enum AccountStates {
    PRESTACION_DEFINIDA = 'PRESTACION_DEFINIDA',
    PRESTACION_ENTRAMITE = 'PRESTACION_TRAMITE'
}
